import { render } from "./points.vue?vue&type=template&id=2bf80bac&scoped=true"
import script from "./points.vue?vue&type=script&lang=js"
export * from "./points.vue?vue&type=script&lang=js"

import "./points.vue?vue&type=style&index=0&id=2bf80bac&lang=scss"
import "./points.vue?vue&type=style&index=1&id=2bf80bac&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf80bac"]])

export default __exports__